import type { TourSection } from './types';

// Secciones del listado global (/audit-logs).
export const auditLogsSections: TourSection[] = [
  {
    id: 'filters',
    label: 'Filtros del historial',
    steps: [
      {
        target: '[data-tour="audit-filters"]',
        title: 'Filtrar acciones',
        content:
          'Filtros para encontrar acciones puntuales: tipo de operación (crear / editar / eliminar), sobre qué entidad (productos, marcas, usuarios), por usuario, por fecha o ver solo las que fallaron.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado',
    steps: [
      {
        target: '[data-tour="audit-table"]',
        title: 'Tabla de acciones',
        content:
          'Quién hizo qué: usuario, tipo de operación, sobre qué (producto, marca, etc), cuándo y si fue exitosa. El color indica el resultado: verde = OK, amarillo = error del cliente, rojo = error del servidor.',
      },
    ],
  },
  {
    id: 'drawer',
    label: 'Ver detalle de una acción',
    steps: [
      {
        target: '[data-tour="audit-table"]',
        title: 'Detalle completo',
        content:
          'Click en cualquier fila de la tabla para abrir un panel lateral con la información completa: URL, datos enviados, respuesta recibida y motivo del error si lo hubo. Útil para investigar incidentes después de que pasaron.',
      },
    ],
  },
];

// Secciones del historial de un producto puntual (/audit-logs/:productId).
export const auditLogsProductSections: TourSection[] = [
  {
    id: 'product-drilldown',
    label: 'Historial del producto',
    steps: [
      {
        target: '[data-tour="audit-product-drilldown"]',
        title: 'Acciones sobre este producto',
        content:
          'Cuando entras al historial de un producto puntual, ves solo las acciones que afectaron ese SKU. Útil para entender qué cambió y cuándo.',
      },
    ],
  },
];
